export const SUBMENU_DISPLAY_NAME = '___ContextMenuSubMenu___';
